import { DictionaryEntry } from '@sdbn/common';
import { MasterDetailListEntry } from '@sdbn/common';

export class ReportingGroupListEntry implements MasterDetailListEntry {
  id: number;
  nameDictionaryKey: string;
  translatedLabel: string;

  constructor(reportingGroupListEntry?: ReportingGroupListEntry) {
    if (reportingGroupListEntry != null) {
      this.id = reportingGroupListEntry.id;
      this.nameDictionaryKey = reportingGroupListEntry.nameDictionaryKey;
    }
  }

  public get listTitle(): string {
    return this.translatedLabel;
  }

  public get listTitleDictionaryKey(): string {
    return null;
  }

  public get listSubTitle(): string {
    return null;
  }

  public get groupIdentifier(): String {
    return null;
  }

  public get childs() : Array<MasterDetailListEntry> {
    return null;
  }

}


export class ReportingGroup {
  id: number;
  name = new DictionaryEntry();
  color1: string;
  backgroundColor1: string;
  color2: string;
  backgroundColor2: string;
  color3: string;
  backgroundColor3: string;
  sortIndex: number;
  stationIds = new Array<number>();
  stationSetIds = new Array<number>();


  constructor(reportingGroup?: ReportingGroup) {
    if (reportingGroup != null) {
      this.id = reportingGroup.id;
      if (reportingGroup.name != null) {
        this.name = new DictionaryEntry(reportingGroup.name);
      }
      this.color1 = reportingGroup.color1;
      this.backgroundColor1 = reportingGroup.backgroundColor1;
      this.color2 = reportingGroup.color2;
      this.backgroundColor2 = reportingGroup.backgroundColor2;
      this.color3 = reportingGroup.color3;
      this.backgroundColor3 = reportingGroup.backgroundColor3;
      this.sortIndex = reportingGroup.sortIndex || 0;
      if (reportingGroup.stationIds != null) {
        for (const id of reportingGroup.stationIds) {
          this.stationIds.push(id);
        }
      }
      if (reportingGroup.stationSetIds != null) {
        for (const id of reportingGroup.stationSetIds) {
          this.stationSetIds.push(id);
        }
      }
    }
  }
}


